import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Input } from 'antd';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';

const propTypes = {
  form: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  extra: PropTypes.string,
  initialValue: PropTypes.string,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  rows: PropTypes.number.isRequired,
  isRequired: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  validator: PropTypes.func,
  disabled: PropTypes.bool,
};

const defaultProps = {
  initialValue: '',
  placeholder: '',
  isRequired: false,
  min: 0,
  max: 99999,
  disabled: false,
};

@autobind
class FormInput extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      form,
      name,
      label,
      extra,
      initialValue,
      placeholder,
      help,
      rows,
      isRequired,
      min,
      max,
      validator,
      disabled,
      ...layoutProps
    } = this.props;

    const { getFieldDecorator } = form;

    const requiredRule = { required: isRequired, message: 'This field should not be empty.' };
    const minRule = min !== undefined ? { min, message: `This field should contain at least ${min} characters.` } : undefined;
    const maxRule = max !== undefined ? { max, message: `This field should contain at most ${max} characters.` } : undefined;
    const rules = [requiredRule, minRule, maxRule, validator].filter(Boolean);

    return (
      <styledComp.AntdFormItem
        {...layoutProps}
        label={label}
        extra={extra}
        help={help}
      >
        {getFieldDecorator(name, {
          rules,
          initialValue,
        })(
          <Input.TextArea
            rows={rows}
            placeholder={placeholder}
            disabled={disabled}
          />,
        )}
      </styledComp.AntdFormItem>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
FormInput.propTypes = propTypes;
FormInput.defaultProps = defaultProps;

export default FormInput;
